import React from 'react';
import { Link } from 'react-router-dom';
import { PATHS, ICONS } from '../../common/constants';
import Actions from '../Actions';
import Avatar from '../Avatar';
import Button from '../Button';
import Empty from '../Empty';
import Icon from '../Icon';
import Overlay from '../Overlay';
import Table, { Hidden } from '../Table';
import Tenant from '../Tenant';
import Search from '../Search';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {
  setContactFormData,
  clearContactFormData,
} from '../../store/actions/contactForm';
import { selectSearch } from '../../store/selectors/search';
import Loader from '../Loader';
import { selectFormLoader } from '../../store/selectors/FormLoader';
import AddSuiteUser from '../AddSuiteUser';
import { selectAuthenticatedUser } from '../../store/selectors/auth';
import { onRequestPhoneCall } from '../../helpers/validationHelper';

class SuiteUsersTable extends React.Component {
  state = {
    showOverlay: false,
  };

  render() {
    const {
      user,
      contacts,
      loader,
      onSubmitContactForm,
      onSearch,
      setContactFormData,
      clearContactFormData,
      sendResetPasswordLinkToUser,
      sendActivationLinkToUser,
      search,
    } = this.props;
    const { showOverlay } = this.state;
    let homeOwnerCheck =
      user &&
      user.roles &&
      user.roles.length > 0 &&
      (user.roles[0].role.name === 'Home Owner' ||
        user.roles[0].role.name === 'Occupant')
        ? true
        : false;
    let theme = localStorage.getItem('theme');

    return (
      <>
        {loader ? <Loader center={true} /> : null}
        <Actions compact>
          <Search
            size="small"
            placeholder="Search People..."
            onChange={onSearch}
          />
          {(user.roles[0].role.name === 'Home Owner' && theme === 'Albaster') ||
          (homeOwnerCheck && theme === 'Rize') ||
          user.roles[0].role.name === 'Realtor' ? null : (
            <Button
              color="teal"
              label="Add Person"
              onClick={() => {
                this.setState({ showOverlay: true });
                clearContactFormData();
                setContactFormData({
                  old: false,
                  firstname: '',
                  lastname: '',
                  email: '',
                  phone: '',
                  formType: 'New',
                });
              }}
              icon={<Icon glyph="user-plus" weight="regular" size="small" />}
              size="small"
            />
          )}
        </Actions>
        {contacts.length > 0 ? (
          <>
            <Table
              columns={[
                {
                  label: 'Contact',
                  sortable: true,
                  accessor: 'firstname',
                  cell: (data) => {
                    let type = data.role;
                    return (
                      <Link
                        style={{
                          cursor:
                            user.roles[0].role.name === 'Admin' ||
                            user.roles[0].role.name === 'Property Developer'
                              ? 'pointer'
                              : 'auto',
                        }}
                        to={
                          user.roles[0].role.name === 'Admin' ||
                          user.roles[0].role.name === 'Property Developer'
                            ? {
                                pathname: PATHS.CONTACTS_VIEW.replace(
                                  ':id',
                                  data.id
                                ),
                                state: {
                                  data: data,
                                },
                              }
                            : {}
                        }
                      >
                        <Tenant
                          headline={`${data.firstname} ${data.lastname}`}
                          avatar={
                            <Avatar
                              badge={ICONS[type]}
                              url={data.profileImage}
                            />
                          }
                        />
                      </Link>
                    );
                  },
                },
                {
                  xsHide: true,
                  label: 'Role',
                  accessor: 'roles[0].role.name',
                  cell: (data) => {
                    let type = data.roles[0].role.name;
                    return (
                      <div
                        style={{
                          display: 'flex',
                          flexDirection: 'row',
                          alignItems: 'center',
                        }}
                      >
                        <div>{type}</div>
                        {data.contactType ? (
                          <div style={{ paddingLeft: 3 }}>
                            {'- ' + data.contactType}{' '}
                          </div>
                        ) : null}
                        {data.isPrimaryContact === true ? (
                          <div
                            style={{
                              display: 'flex',
                              color: '#48C2BF',
                              justifyContent: 'center',
                              alignItems: 'center',
                              paddingLeft: 5,
                            }}
                          >
                            <Icon glyph="sun" weight="regular" size="small" />
                          </div>
                        ) : (
                          <div />
                        )}
                      </div>
                    );
                  },
                },
                {
                  label: 'Phone',
                  accessor: 'phone',
                  cell: (data) => onRequestPhoneCall(data.phone),
                },
                {
                  xsHide: true,
                  label: 'Email',
                  accessor: 'email',
                },
                {
                  cell: (data) => (
                    <Hidden>
                      {user.roles[0].role.name === 'Admin' ||
                      user.roles[0].role.name === 'Super Admin' ||
                      user.roles[0].role.name === 'Property Developer' ? (
                        <Button
                          color="semantic"
                          label={<Icon glyph="pencil" weight="light" />}
                          onClick={() => {
                            this.setState({ showOverlay: true });
                            setContactFormData(data);
                            setContactFormData({
                              old: true,
                              formType: 'New',
                            });
                          }}
                        />
                      ) : null}
                    </Hidden>
                  ),
                },
              ]}
              data={contacts}
            />
          </>
        ) : (
          <Empty
            direction="ttb"
            headline="No people yet"
            strapline="Add your people here so it’s easier for you to manage."
            searchIsActive={search && search.contacts ? search.contacts : ''}
            cta={
              <>
                <Button
                  color="teal"
                  label="Add Person"
                  onClick={() => {
                    this.setState({ showOverlay: true });
                    clearContactFormData();
                    setContactFormData({
                      old: false,
                      firstname: '',
                      lastname: '',
                      email: '',
                      phone: '',
                      formType: 'New',
                    });
                  }}
                  icon={<Icon glyph="user" weight="light" size="small" />}
                  size="small"
                />
              </>
            }
            image={<img alt="No people yet" src="/assets/empty/contacts.svg" />}
          />
        )}
        <Overlay
          showOverlay={showOverlay}
          content={
            <AddSuiteUser
              suite={this.props.suite}
              onAddingExistingUser={this.props.onAddingExistingUser}
              onClose={() =>
                this.setState({ showOverlay: false }, () =>
                  clearContactFormData()
                )
              }
              onSubmit={(data, actionType) => {
                onSubmitContactForm(data, actionType);
              }}
              sendResetPasswordLinkToUser={sendResetPasswordLinkToUser}
              sendActivationLinkToUser={sendActivationLinkToUser}
            />
          }
        />
      </>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  user: selectAuthenticatedUser(state),
  search: selectSearch(state),
  loader: selectFormLoader(state),
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      setContactFormData,
      clearContactFormData,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(SuiteUsersTable);
